const SearchResultItem = {
  tag: 'item',
  attributes: {
    id: {
      name: 'id',
      untransform: (value) => parseInt(value),
    },
    type: {
      name: 'type',
    }
  },
  fields: {
    name: {
      tag: 'name',
      attributes: {
        value: {},
      },
    },
    publishedAt: {
      tag: 'yearpublished',
      attributes: {
        value: {
          untransform: (value) => parseInt(value),
        },
      },
    }
  }
};

const BoardgameItem = {
  tag: 'item',
  attributes: {
    type: {},
    id: {
      untransform: (value) => parseInt(value),
    },
  },
  fields: {
    thumbnail: {},
    image: {},
    name: {
      tag: 'name',
      attributes: {
        value: {},
        type: {},
      },
    },
    description: {},
    minPlayers: {
      tag: 'minplayers',
      attributes: {
        value: {
          untransform: (value) => parseInt(value),
        },
      },
    },
    maxPlayers: {
      tag: 'maxplayers',
      attributes: {
        value: {
          untransform: (value) => parseInt(value),
        },
      },
    },
    minPlayTime: {
      tag: 'minplaytime',
      attributes: {
        value: {
          untransform: (value) => parseInt(value),
        },
      },
    },
    maxPlayTime: {
      tag: 'maxplaytime',
      attributes: {
        value: {
          untransform: (value) => parseInt(value),
        },
      },
    }
  }
};

export const SearchResultSchema = {
  tag: 'items',
  attributes: {
    total: {
      untransform: (value) => parseInt(value),
    },
  },
  fields: {
    items: SearchResultItem,
  },
  array: true,
};

export const BoardgameDetailSchema = {
  tag: 'items',
  fields: {
    item: BoardgameItem,
  },
  array: true,
}